/**
 * Aggregate hourly timeseries [{ timestamp, value }] into weekday×hour UTC points.
 * weekday: 0=Sunday … 6=Saturday (Date#getUTCDay).
 */
export const aggregateHourlyToWeekdayHour = series => {
  const buckets = new Map();
  (series || []).forEach(point => {
    const ts = Number(point.timestamp);
    if (!Number.isFinite(ts)) return;
    const date = new Date(ts * 1000);
    const weekday = date.getUTCDay();
    const hour = date.getUTCHours();
    const key = `${weekday}-${hour}`;
    buckets.set(key, (buckets.get(key) || 0) + (Number(point.value) || 0));
  });

  return Array.from(buckets.entries()).map(([key, value]) => {
    const [weekday, hour] = key.split('-').map(Number);
    return { weekday, hour, value };
  });
};
